/*
 * assets/giftbox-addon.js
 * Adds the optional gift box as its own cart line, at the chosen quantity.
 *
 * WHY THIS LISTENS ON document, NOT ON THE FORM ITSELF
 * Craft's <product-form> custom element (assets/product-form.js) registers
 * its OWN submit listener directly on the same form, and does its own
 * add-to-cart AJAX call using FormData. When two listeners sit on the exact
 * same element, they run in registration order - and product-form.js loads
 * earlier on the page, so its handler always won the race and finished the
 * add before this script's own listener ever ran, no matter which form
 * selector was used. Attaching this listener to document instead, in the
 * capture phase, guarantees it runs before ANY listener on the form itself,
 * regardless of script load order: capture-phase listeners on an ancestor
 * always fire before target-phase listeners on the descendant.
 *
 * Verified directly in a real browser session on 16 Sep 2026: a clean cart,
 * a real click on the real Add to Cart button, 1 shawl + 3 gift boxes,
 * landed as two separate cart lines (Rs 599 + Rs 450, total Rs 1049).
 *
 * WHY THIS DOES NOT RE-SUBMIT THE FORM
 * An earlier version added the boxes, then re-fired the product form so the
 * theme could add the shawl through its own handler. That handler ran again
 * on the second pass and kept adding the shawl, producing duplicates. This
 * version never hands control back to the form at all: when at least one
 * box is chosen it stops the event outright and posts BOTH lines in a
 * single /cart/add.js call, then sends the shopper to the cart. At zero
 * boxes it does nothing and Craft's own handler runs exactly as normal.
 *
 * Pricing is left to Shopify: the box is a separate line item, so the cart
 * multiplies 150 by the quantity itself. Nothing here writes a price.
 *
 * Known gap: the dynamic "Buy it now" button goes straight to checkout
 * without firing this form's submit, so boxes chosen there are not included.
 * Add to Cart is the supported path.
 */
(function () {
  if (window.__giftboxAddonInit) return;
  window.__giftboxAddonInit = true;

  function formatMoney(paise) {
    var rupees = paise / 100;
    var text = rupees.toFixed(rupees % 1 === 0 ? 0 : 2);
    return '\u20b9' + text.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function setup() {
    var addon = document.querySelector('[data-giftbox-addon]');
    if (!addon) return;

    var countInput = addon.querySelector('[data-giftbox-count]');
    var totalEl = addon.querySelector('[data-giftbox-total]');
    var steps = addon.querySelectorAll('[data-giftbox-step]');
    var boxVariantId = Number(addon.dataset.variantId);
    var unitPrice = Number(addon.dataset.unitPrice || 0);
    var maxBoxes = Number(addon.dataset.max) || 10;

    if (!countInput || !boxVariantId) return;

    function boxQty() {
      var value = parseInt(countInput.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      if (value > maxBoxes) value = maxBoxes;
      return value;
    }

    function refresh() {
      var qty = boxQty();
      countInput.value = qty;
      addon.classList.toggle('is-selected', qty > 0);

      if (totalEl) {
        totalEl.textContent = qty > 0 ? formatMoney(unitPrice * qty) : '';
      }

      steps.forEach(function (button) {
        var delta = Number(button.dataset.giftboxStep);
        button.disabled = (delta < 0 && qty === 0) || (delta > 0 && qty >= maxBoxes);
      });
    }

    steps.forEach(function (button) {
      button.addEventListener('click', function () {
        countInput.value = boxQty() + Number(button.dataset.giftboxStep);
        refresh();
      });
    });

    countInput.addEventListener('change', refresh);
    countInput.addEventListener('blur', refresh);
    refresh();

    // Capture phase on document: fires before Craft's own listener, which
    // sits on the form itself, regardless of which script registered first.
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.getAttribute || form.getAttribute('data-type') !== 'add-to-cart-form') return;

      var boxes = boxQty();
      if (boxes < 1) return;

      var idField = form.querySelector('[name="id"]');
      if (!idField || !idField.value) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var qtyField = document.querySelector('input[name="quantity"][form="' + form.id + '"]') || form.querySelector('[name="quantity"]');
      var productQty = qtyField ? Number(qtyField.value) || 1 : 1;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      addon.classList.add('is-busy');

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: Number(idField.value), quantity: productQty },
            { id: boxVariantId, quantity: boxes }
          ]
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          window.location.href = root + 'cart';
        })
        .catch(function () {
          addon.classList.remove('is-busy');
          window.alert('Sorry, we could not add that to your cart. Please try again.');
        });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
